import { useHttp } from '@/api'
import { httpApi } from '@/api/api'

/**
 * 新規得意先情報
 */
export function AddMgrMstInfo(data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.AddMgrMstInfo, data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 編集得意先情報
 */
export function ChangeMgrMstInfo(data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.ChangeMgrMstInfo, data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 検索担当者情報
 */
export function GetMgrMstInfo(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.GetMgrMstInfo, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 削除得意先情報
 */
export function DeleteMgrMstInfo(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.DeleteMgrMstInfo, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 検索担当者マスタ情報
 */
// export function GetMgrMstInfo() {
//   return new Promise((resolve, reject) => {
//     useHttp()
//       .request(httpApi.GetMgrMstInfo)
//       .then(res => {
//         resolve(res)
//       })
//       .catch(err => {
//         reject(err)
//       })
//   })
// }

